module.exports = __webpack_public_path__ + "static/media/logo-black.fec4f6ca.png";